// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__2ANCG"};